import { render, staticRenderFns } from "./c_product.vue?vue&type=template&id=4f240607&scoped=true"
import script from "./c_product.vue?vue&type=script&lang=js"
export * from "./c_product.vue?vue&type=script&lang=js"
import style0 from "./c_product.vue?vue&type=style&index=0&id=4f240607&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f240607",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f240607')) {
      api.createRecord('4f240607', component.options)
    } else {
      api.reload('4f240607', component.options)
    }
    module.hot.accept("./c_product.vue?vue&type=template&id=4f240607&scoped=true", function () {
      api.rerender('4f240607', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_product.vue"
export default component.exports